import type { InputComponentsMap } from '@frontend/formEngine/editForm/editForm.types';
import { AlternativeAddress } from './AlternativeAddress';
import { AlternativeAddressCheckbox } from './AlternativeAddressCheckbox';

export function getPatientAlternativeAddressComponents(): InputComponentsMap<
    'alternativeAddress' | 'sendToAlternativeAddress'
> {
    const map: InputComponentsMap<'alternativeAddress' | 'sendToAlternativeAddress'> = new Map();

    map.set('sendToAlternativeAddress', <AlternativeAddressCheckbox />);
    map.set('alternativeAddress', <AlternativeAddress />);

    return map;
}
